/**
 * @module removeTextMargin
 * See ticket https://pm.tdintern.de/jira/browse/CCWP-39
 */

/*

 @todo, Discuss it with PO whether we need text-with-background feature or not.
 if we need it , then make this javascript also works on Neos Backend
     please see ticket CCWP-39
     please see the styleGuide on page 21 ,
        https://pm.tdintern.de/jira/secure/attachment/64159/20190425_CREATON%20Digital%20Styleguide_v4.pdd
*/

$(document).ready(function () {
    $('.js_text-remove-margin').closest('h1, h2, h3, h4, h5, h6, li , p, th, td').addClass('text-no-margin-bottom')
})
